const env = process.env.REACT_APP_ENVIRONMENT || 'local';

const baseUrls = {
  local: process.env.REACT_APP_API_BASE_URL_LOCAL,
  staging: process.env.REACT_APP_API_BASE_URL_STAGING,
  production: process.env.REACT_APP_API_BASE_URL_PRODUCTION,
};

const API_BASE_URL = baseUrls[env] || baseUrls.local || 'http://localhost:5001/api';

export default API_BASE_URL; 